module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Dashboard Search")]), _vm._v(" "), _c('div', {
    staticClass: "card-block"
  }, [_c('SearchBar', {
    attrs: {
      "total": _vm.total
    },
    on: {
      "queryChanged": _vm.queryChanged,
      "searchTypeChanged": _vm.searchTypeChanged,
      "perPageChanged": _vm.perPageChanged
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-block spinner-parent"
  }, [_c('spinner', {
    ref: "spinner",
    attrs: {
      "size": "md",
      "text": "Loading ..."
    }
  }), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [(_vm.total) ? _c('table', {
    staticClass: "entities table table-bordered table-striped table-sm"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.entities), function(item) {
    return _c('tr', {
      key: item._id + item._source.snippet.type,
      attrs: {
        "data-id": item._id + item._source.snippet.type
      }
    }, [_c('td', [_vm._v(_vm._s(item._source.id))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow text-center"
    }, [_c('img', {
      staticStyle: {
        "max-height": "100px"
      },
      attrs: {
        "src": item._source.snippet.thumb,
        "alt": ""
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item._source.snippet.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item._source.snippet.type))]), _vm._v(" "), _c('td', {
      staticClass: "table-list__cell--narrow"
    }, [(_vm.$_allowUpdating(item)) ? _c('router-link', {
      staticClass: "btn btn-primary btn-sm",
      attrs: {
        "to": ("content/" + (item._source.type) + "/edit/" + (item._source.id))
      }
    }, [_vm._v("\n                  Edit\n                ")]) : _vm._e(), _vm._v(" "), _c('open-on-site', {
      attrs: {
        "source-route": item._source.snippet.url
      }
    })], 1)])
  }), 0)]) : _vm._e()]), _vm._v(" "), (!_vm.isLoading && !_vm.searchQuery && _vm.total === 0) ? _c('div', [_vm._v("Your results will be displayed here")]) : (!_vm.isLoading && _vm.total === 0) ? _c('div', [_vm._v("There are no entities for your request")]) : _vm._e(), _vm._v(" "), _c('nav', [_c('pager', {
    attrs: {
      "total": _vm.total,
      "offset": _vm.offset,
      "size": _vm.perPage
    },
    on: {
      "page-changed": _vm.$_changePage
    }
  })], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Thumbnail")]), _vm._v(" "), _c('th', [_vm._v("Title")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Actions")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d32d6894","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mainSearch/DashboardSearch.vue
// module id = 991
// module chunks = 0